// dropdown.js — with custom_true support
// ✅ Any option with custom_true: true → triggers manual text input in Dropdwon
// Usage example in propertyInputs:
//   { dropdown_id: 5, ... } → dropdown uses this array
//   Add { value: "custom", label: "Other / Enter Manually", custom_true: true, custom_placeholder: "e.g. 6 BHK, Penthouse…" }

const dropdown = [
  {
    id: 1, name: "property_direction",
    options: [
      { value: 1, label: "North" }, { value: 2, label: "South" },
      { value: 3, label: "East" },  { value: 4, label: "West" },
      { value: 5, label: "North East" }, { value: 6, label: "North West" },
      { value: 7, label: "South East" }, { value: 8, label: "South West" },
    ],
  },
  {
    id: 2, name: "gated_community",
    options: [
      { value: 1, label: "Yes" },
      { value: 2, label: "No" },
    ],
  },
  {
    id: 3, name: "furnishing_status",
    options: [
      { value: 1, label: "Fully Furnished" },
      { value: 2, label: "Semi Furnished" },
      { value: 3, label: "Non Furnished" },
    ],
  },
  {
    id: 4, name: "property_age",
    options: [
      { value: 1, label: "New Property" },
      { value: 2, label: "Less than 5 Years" },
      { value: 3, label: "5 – 10 Years" },
      { value: 4, label: "More than 10 Years" },
    ],
  },
  {
    id: 5, name: "bhk_type",
    options: [
      { value: 1, label: "1 BHK" }, { value: 2, label: "2 BHK" },
      { value: 3, label: "3 BHK" }, { value: 4, label: "4 BHK" },
      { value: 5, label: "5 BHK" }, { value: 6, label: "Studio" },
      { value: "custom", label: "Add Custom", custom_true: true, custom_placeholder: "e.g. 6 BHK, 2B3H3K" },
    ],
  },
  {
    id: 6, name: "floor_number",
    options: [
      { value: 0,  label: "Ground" }, { value: 1,  label: "1st" },
      { value: 2,  label: "2nd" },   { value: 3,  label: "3rd" },
      { value: 4,  label: "4th" },   { value: 5,  label: "5th" },
      { value: 6,  label: "6th" },   { value: 7,  label: "7th" },
      { value: 8,  label: "8th" },   { value: 9,  label: "9th" },
      { value: 10, label: "10th" },  { value: 11, label: "11th" },
      { value: 12, label: "12th" },  { value: 15, label: "15th" },
      { value: 20, label: "20th" },
      { value: "custom", label: "Add Custom", custom_true: true, custom_placeholder: "e.g. Basement, Terrace…" },
    ],
  },
  {
    id: 7, name: "total_floors",
    options: [
      { value: 0,  label: "Ground Floor" },
      { value: 1,  label: "G+1" },  { value: 2,  label: "G+2" },
      { value: 3,  label: "G+3" },  { value: 4,  label: "G+4" },
      { value: 5,  label: "G+5" },  { value: 6,  label: "G+6" },
      { value: 7,  label: "G+7" },  { value: 8,  label: "G+8" },
      { value: 9,  label: "G+9" },  { value: 10, label: "G+10" },
      { value: 12, label: "G+12" }, { value: 15, label: "G+15" },
      { value: 20, label: "G+20" }, { value: 25, label: "G+25" },
      { value: 30, label: "G+30" },
      { value: "custom", label: "Add Custom", custom_true: true, custom_placeholder: "e.g. 35, 40…" },
    ],
  },
  {
    id: 8, name: "availability_status",
    options: [
      { value: 1, label: "Under Construction" },
      { value: 2, label: "Ready to Move" },
      { value: 3, label: "New Launch" },
    ],
  },
];

export default dropdown;